
  import {
    Component,
    Vue
  } from "vue-property-decorator";
  import PageFooter from '@/components/page-footer.vue';
  import Message from '@/components/message.vue';
  import refundAddressInfo from './components/refund-address-info.vue';
  import {
    getProviderReturnLogistics,
    delProviderReturnLogistics,
  } from '@/api/logistics'

  @Component({
    name: 'refund-address',
    components: {
      PageFooter,
      refundAddressInfo,
      'slz-message': Message
    }
  })
  export default class RefundAddress extends Vue {
    private list: any = [];
    private currentId = 0;
    private currentData:any = {}
    private showMessage = false;
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;
    private nameKey = '';
    private showDialog = false;
    private dialogType = ''

    private mounted() {
      this.getList()
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.pageNo = 1;
      this.nameKey = '';
      this.getList();
    }

    private async getList() {
      let params: any = {
        Skip: (this.pageNo-1)*this.pageSize,
        Take: this.pageSize,
        Keywords: this.nameKey
      }

      try {
        const res: any = await getProviderReturnLogistics(params);
        this.list = res.Result.Results || [];
        this.total = res.Result.Total;
      } catch (e) {
        console.log(e)
      }
    }

    private toCreate() {
      this.dialogType = 'create';
      this.currentData = {};
      this.showDialog = true;
    }

    private toDetail(row: any) {
      // this.currentId = row.id;
      this.currentData = row;
      this.dialogType = 'edit';
      this.showDialog = true;
    }

    private changePage(num: number) {
      this.pageNo = num
      this.getList()
    }

    private handleDel(row: any) {
      this.currentId = row.Id;
      // console.log(row)
      this.showMessage = true;
    }

    private async delConfirm() {
      if (!this.currentId) return;
      try {
        await delProviderReturnLogistics({
          Id: +this.currentId
        })
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.getList()
      } catch (e) {
        console.log(e)
      }
    }

    private updateInfo() {
      this.pageNo = 1;
      this.nameKey = '';
      this.getList();
    }
  }
